module.exports = __webpack_public_path__ + "static/media/p2detail.ae700f21.jpg";